import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['toggleMenu'])
  },
  computed: {
    GetCurrentLang () {
      return this.$route.params.lang || 'pt'
    }
  },
  created () {
    this.toggleMenu(false)
  },
  watch: {
    '$route.params.lang': (lang) => {
      if (lang) {
        setTimeout(() => {
          window.location.reload()
        }, 300)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/AsideMenuCtrlMixin.js